'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_User(id_$_lo, id_$_hi, account, email, firstName, lastName, active, created, lastUpdated, lastLoggedIn, deleted, deletedDate, oauth, mustChangePasswordOnNextLogin, userPreferences) {
  this.is = 0;
  this.it = 0;
  this.c7 = null;
  this.k3 = null;
  this.kK = null;
  this.ll = null;
  this.mj = false;
  this.mk = null;
  this.mo = null;
  this.mn = null;
  this.ml = false;
  this.mm = null;
  this.mq = null;
  this.mp = false;
  this.mr = null;
  this.is = id_$_lo;
  this.it = id_$_hi;
  this.c7 = account;
  this.k3 = email;
  this.kK = firstName;
  this.ll = lastName;
  this.mj = active;
  this.mk = created;
  this.mo = lastUpdated;
  this.mn = lastLoggedIn;
  this.ml = deleted;
  this.mm = deletedDate;
  this.mq = oauth;
  this.mp = mustChangePasswordOnNextLogin;
  this.mr = userPreferences;
}
export { $c_Lmealorama_User as $c_Lmealorama_User };
$p = $c_Lmealorama_User.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_User;
/** @constructor */
function $h_Lmealorama_User() {
}
export { $h_Lmealorama_User as $h_Lmealorama_User };
$h_Lmealorama_User.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 2645995);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.is, this.it)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.c7));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.k3));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kK));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ll));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.mj ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mk));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mo));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mn));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.ml ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mm));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mq));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.mp ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.mr));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 14);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_User)) {
    if ((((this.mj === x$0.mj) && (this.ml === x$0.ml)) && (this.mp === x$0.mp))) {
      var x_$_lo = this.is;
      var x_$_hi = this.it;
      var $x_9 = x$0;
      var x$1_$_lo = $x_9.is;
      var x$1_$_hi = $x_9.it;
      var $x_8 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$2 = this.c7;
      var x$2$1 = x$0.c7;
      var $x_7 = ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      var $x_7 = false;
    }
    if ((($x_7 && (this.k3 === x$0.k3)) && (this.kK === x$0.kK))) {
      var x$3 = this.ll;
      var x$4 = x$0.ll;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.mk;
      var x$6 = x$0.mk;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.mo;
      var x$8 = x$0.mo;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.mn;
      var x$10 = x$0.mn;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.mm;
      var x$12 = x$0.mm;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.mq;
      var x$14 = x$0.mq;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.mr;
      var x$16 = x$0.mr;
      return ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 14;
});
$p.r = (function() {
  return "User";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.is, this.it);
      break;
    }
    case 1: {
      return this.c7;
      break;
    }
    case 2: {
      return this.k3;
      break;
    }
    case 3: {
      return this.kK;
      break;
    }
    case 4: {
      return this.ll;
      break;
    }
    case 5: {
      return this.mj;
      break;
    }
    case 6: {
      return this.mk;
      break;
    }
    case 7: {
      return this.mo;
      break;
    }
    case 8: {
      return this.mn;
      break;
    }
    case 9: {
      return this.ml;
      break;
    }
    case 10: {
      return this.mm;
      break;
    }
    case 11: {
      return this.mq;
      break;
    }
    case 12: {
      return this.mp;
      break;
    }
    case 13: {
      return this.mr;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
$p.aSK = (function() {
  var $x_1 = this.kK;
  var this$1 = this.ll;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(($x_1 + (this$1.b() ? "" : (" " + this$1.i()))));
});
function $isArrayOf_Lmealorama_User(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k4)));
}
export { $isArrayOf_Lmealorama_User as $isArrayOf_Lmealorama_User };
var $d_Lmealorama_User = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_User, "mealorama.User", ({
  k4: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_User as $d_Lmealorama_User };
//# sourceMappingURL=mealorama.-User.js.map
